import type { OnInit } from '@angular/core';
import { Component, inject, input, ViewEncapsulation } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

import { Language } from '@helsana/data-access';

import { ComponentTypeEnum, PriceCalculator, ProductConfig, SpeechBubbleDirection } from '@helsana/price-calculator';

@UntilDestroy()
@Component({
  selector: 'price-calculator-component',
  templateUrl: './price-calculator.component.html',
  styleUrls: ['./price-calculator.component.scss'],
  imports: [
    TranslocoModule,
    PriceCalculator
  ],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class PriceCalculatorComponent implements OnInit {
  language = input<Language>(Language.de);
  componentType = input.required<ComponentTypeEnum>();
  portalBaseUrl = input.required<string>();
  promosUrl = input.required<string>();
  productPagePaths = input<string[] | undefined>();
  tooltipContent = input<string | undefined>();
  productConfig = input<ProductConfig[]>();
  doctorSearchPath = input<string>();
  speechBubbleDirection = input<SpeechBubbleDirection>();

  private translocoService = inject(TranslocoService);

  ngOnInit() {
    this.translocoService.setActiveLang(this.language());
  }
}
